import React, { useMemo } from 'react';

import { ThemeProvider, createTheme } from '@mui/material';

import defaultTheme from './defaultTheme.json';
import darkTheme from './darkTheme.json';
import { useAuthStore } from '@store/authStore';

const defaultTedTheme = createTheme(defaultTheme);
const darkTedTheme = createTheme(darkTheme);

const BRANDING_KEYS = [
  'logoName',
  'loginLogoName',
  'copyRights',
  'favicon',
  'tabName',
];

const TedTheme = ({ children }) => {
  const { userTheme, colorMode } = useAuthStore();

  const theme = useMemo(() => {
    if (colorMode === 'light') {
      return userTheme || defaultTedTheme;
    }
    if (!userTheme) {
      return darkTedTheme;
    }

    const branding = BRANDING_KEYS.reduce((acc, key) => {
      if (userTheme[key]) {
        acc[key] = userTheme[key];
      }
      return acc;
    }, {});

    return createTheme({ ...darkTheme, ...branding });
  }, [userTheme, colorMode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default TedTheme;
